import { IconType } from 'react-icons'
import {
  FaAmazon,
  FaAppStore,
  FaCreditCard,
  FaDiscord,
  FaEnvelope,
  FaFacebookF,
  FaGithub,
  FaGooglePlay,
  FaInstagram,
  FaLinkedin,
  FaMusic,
  FaPinterestP,
  FaPodcast,
  FaSnapchat,
  FaSoundcloud,
  FaSpotify,
  FaTelegram,
  FaThreads,
  FaTiktok,
  FaTwitch,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from 'react-icons/fa6'
import { SiClubhouse } from 'react-icons/si'

export const iconMapping: { [key: string]: IconType } = {
  Snapchat: FaSnapchat,
  Instagram: FaInstagram,
  Threads: FaThreads,
  Email: FaEnvelope,
  Facebook: FaFacebookF,
  Youtube: FaYoutube,
  Twitter: FaTwitter,
  Tiktok: FaTiktok,
  Whatsapp: FaWhatsapp,
  Telegram: FaTelegram,
  Amazon: FaAmazon,
  AndroidPlayStore: FaGooglePlay,
  AppleAppStore: FaAppStore,
  AppleMusic: FaMusic,
  ApplePodcast: FaPodcast,
  Clubhouse: SiClubhouse,
  Discord: FaDiscord,
  Github: FaGithub,
  Linkedin: FaLinkedin,
  Payment: FaCreditCard,
  Pinterest: FaPinterestP,
  Spotify: FaSpotify,
  Twitch: FaTwitch,
  Soundcloud: FaSoundcloud,
}
